import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
export function Garantia() {
  return <section id="garantia" className="bg-crema py-[100px]" data-id="element-144">
      <div className="container-custom" data-id="element-145">
        <SectionHeader eyebrow="Riesgo cero" title={<>
              Garantía de Hierro
              <br data-id="element-147" />
              de 7 Días
            </>} theme="light" data-id="element-146" />

        <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.7,
        type: 'spring',
        stiffness: 80
      }} className="bg-blanco border-2 border-verde-claro rounded-[16px] p-[60px_48px] text-center max-w-[680px] mx-auto relative mt-[60px] max-sm:p-[40px_24px] shadow-[0_0_60px_rgba(74,158,109,0.1)]" data-id="element-148">
          <motion.div initial={{
          scale: 0,
          rotate: -20
        }} whileInView={{
          scale: 1,
          rotate: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3,
          duration: 0.6,
          type: 'spring',
          stiffness: 120
        }} className="mx-auto mb-7" data-id="element-149">
            <img src="https://i.postimg.cc/8zMRv1fQ/selo-garantia-png-2.webp" alt="Garantía de Satisfacción 7 días" className="w-28 h-28 object-contain mx-auto drop-shadow-[0_4px_20px_rgba(45,122,82,0.3)]" data-id="element-150" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5,
          duration: 0.5,
          type: 'spring'
        }} className="font-display text-[72px] font-black text-verde-oscuro leading-none mb-2" data-id="element-151">
            7 <span className="text-[28px]" data-id="element-152">días</span>
          </motion.div>

          <h3 className="font-display text-[24px] font-bold text-verde-oscuro mb-5" data-id="element-153">
            Yo asumo todo el riesgo. Vos no arriesgás nada.
          </h3>

          <p className="text-[16px] text-gris-oscuro leading-[1.8] max-w-[520px] mx-auto mb-4" data-id="element-154">
            Descargá el protocolo, aplicalo durante 72 horas.{' '}
            <strong className="text-verde-oscuro" data-id="element-155">
              Si no sentís un alivio real en tu esófago, te devuelvo cada
              centavo.
            </strong>{' '}
            Sin preguntas. Sin formularios. Sin letra chica. Simplemente
            escribinos dentro de los 7 días y te reembolsamos el 100%.
          </p>

          <p className="text-[15px] text-verde font-medium leading-[1.6] max-w-[520px] mx-auto bg-verde/10 rounded-[8px] p-4" data-id="element-156">
            ¿Por qué ofrezco esta garantía? Porque sé que funciona. Y si no
            funciona para vos, no quiero tu dinero.
          </p>
        </motion.div>
      </div>
    </section>;
}